import { render, staticRenderFns } from "./ExamineDetail.vue?vue&type=template&id=9b4f5c3e&scoped=true&"
import script from "./ExamineDetail.vue?vue&type=script&lang=js&"
export * from "./ExamineDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamineDetail.vue?vue&type=style&index=0&id=9b4f5c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4f5c3e",
  null
  
)

component.options.__file = "ExamineDetail.vue"
export default component.exports